(function() {
  var playCounter = 0;
  var appFeature = document.querySelectorAll('.x-app-feature');
  var appFeatureImage = document.querySelector('.x-feature-movie source');
  var media = document.querySelector('.x-feature-movie');
  var progress = document.querySelectorAll('.x-progress-spinner');
  var container = document.querySelector('.x-app-features-list');
  var mainContainer = document.querySelector('.x-app-features-list .col-layout');

  function stopMedia() {
    media.pause();
    media.currentTime = 0;
  }

  function stopSpinner() {
    progress.forEach(function (spinner) {
      spinner.style.strokeDasharray = '0 25';
    });
  }

  function playMedia() {
    media.load();
    media.play();
  }

  function updateProgressBar(index) {
    var percentage = Math.ceil((25 / media.duration) * media.currentTime);
    progress[index].style.strokeDasharray = percentage + ' 25';
  }

  function inView() {
    if(document.contains(container)) {
      var windowHeight = window.innerHeight;
      var scrollY = window.scrollY || window.pageYOffset;
      var scrollPosition = scrollY + windowHeight;
      var elementHeight = container.clientHeight;
      var elementPosition = container.getBoundingClientRect().top + scrollY + elementHeight;
      if (scrollPosition > elementPosition) {
        return true;
      }
      return false;
    }
  }

  function playOnScroll() {
    if (inView() && playCounter === 0) {
      appFeature[0].classList.add('app-features-playing');
      playMedia();
      if(media.readyState >= 1) {
        setHeight();
      }
      media.addEventListener('timeupdate', function () {
        updateProgressBar(0);
      }, false);
      playCounter++;
    }
  }


  function playMovie() {
    appFeature.forEach(function (element, index) {
      element.addEventListener('click', function () {
        stopMedia();
        appFeatureImage.src = element.dataset.video;
        appFeature.forEach(function (item) {
          item.classList.remove('app-features-active');
          item.classList.remove('app-features-playing');
        });
        element.classList.add('app-features-active');
        element.classList.add('app-features-playing');
        playMedia();
        media.addEventListener('timeupdate', function () {
          stopSpinner();
          updateProgressBar(index);
        }, false);
      });
    });
  }

  function setHeight() {
    if(document.contains(container)) {
      resetHeight();
      var mainContainerHeight = container.clientHeight;
      container.style.height = mainContainerHeight + mainContainer.style.paddingTop + mainContainer.style.paddingBottom + 'px';
    }
  }

  function resetHeight() {
    container.style.height = 'auto';
  }

  if(document.contains(container)) {
    playMovie();
  }

  window.addEventListener('scroll', playOnScroll);
  window.addEventListener('DOMContentLoaded', setHeight);
  window.addEventListener('resize', setHeight);

}());

